// ============================================================
// StatusBadge Component
// ============================================================

import { Box, Typography } from '@mui/material';
import { tokens } from '@/theme/tokens';

const statusConfig = {
  success: { bg: tokens.colors.success.main, color: tokens.colors.success.main },
  warning: { bg: tokens.colors.warning.main, color: tokens.colors.warning.main },
  error: { bg: tokens.colors.error.main, color: tokens.colors.error.main },
  info: { bg: tokens.colors.primary.main, color: tokens.colors.primary.main },
  default: { bg: tokens.colors.grey[500], color: tokens.colors.grey[600] },
};

export function StatusBadge({ status, label }) {
  const config = statusConfig[status] || statusConfig.default;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1.25,
        py: 0.35,
        borderRadius: tokens.radius.full,
        backgroundColor: `${config.bg}15`, // 15% opacity
        border: `1px solid ${config.bg}30`,
        lineHeight: 1,
      }}
    >
      <Box
        sx={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          backgroundColor: config.bg,
          flexShrink: 0,
        }}
      />
      <Typography
        variant="caption"
        sx={{
          color: config.color,
          fontWeight: 600,
          lineHeight: 1,
          display: 'inline-flex',
          alignItems: 'center',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
